import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import CarIcon from "@public/images/icons/CarIcon.svg";
import {
  Card,
  Header,
  Title,
  Body,
  IconContainer,
  AddressContainer,
  AddressText,
  ChangeButton,
} from "./styles";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
  };
};

const CarLocationCard = (props: any) => {
  const { is_visible, card_title, address, actions } = props;
  if (!is_visible) return <></>;

  const { on_change_click } = actions || {};

  const handleChangeClick = () => {
    if (on_change_click && Array.isArray(on_change_click)) {
      on_change_click.forEach((action: any) => {
        if (action && typeof action.funCall === "function") {
          action.funCall(action.args || {});
        }
      });
    }
  };

  return (
    <Card>
      <Header>
        <Title>{card_title}</Title>
      </Header>
      <Body>
        <IconContainer>
          <CarIcon width={20} height={20} />
        </IconContainer>
        <AddressContainer>
          <AddressText>{address || ""}</AddressText>
        </AddressContainer>
        <ChangeButton onClick={handleChangeClick}>Change</ChangeButton>
      </Body>
    </Card>
  );
};

export default connect(mapStateToProps)(CarLocationCard);
